module.exports = __webpack_public_path__ + "img/ennetix-report-page2.8aa66941.png";